<template>
  <!-- HMG, HMG1x2 -->
  <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]">
    <!-- HMG 1X2 -->
    <template v-if="bettyp == hmg1x2BetType || bettyp == rhmg1x2BetType">
      <div data-template="template1" class="wrap-template template1">
        <div class="vrow items-center template-title is_fold">
          <div class="play-name col" @click="showLeg()">
            <span class="ellipsis">{{ getTitleCaption(bettyp) }}</span>
          </div>
          <div style="width: 37px;" @click="setToTop($event)">
            <span class="set_top" style="display: none;">
              <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
            </span>
          </div>
        </div>
        <template v-if="show">
          <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][bettyp]).length)">
            <template
              v-if="newAllBetEvent.od[plytyp][bettyp][Object.keys(newAllBetEvent.od[plytyp][bettyp])[subMatchKey]]">
              <template v-if="subMatchKey == 0">
                <div class="handicap m-1x2">
                  <div class="handicap-item os-1 no_border_bottom">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="item-label bet-ellipsis ellipsis">
                              <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_1HT'] }}</span>
                              <span class="ellipsis-wrap"></span>
                            </div>
                          </div>
                        </div>
                        <odd1x2 :event="newAllBetEvent" :team="teamHome" :plyType="plytyp" :betType="bettyp" ref="team1" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1 no_border_bottom">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="item-label bet-ellipsis ellipsis">
                              <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_2HT'] }}</span>
                              <span class="ellipsis-wrap"></span>
                            </div>
                          </div>
                        </div>
                        <odd1x2 :event="newAllBetEvent" :team="teamAway" :plyType="plytyp" :betType="bettyp" ref="team2" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                  <div class="handicap-item os-1 no_border_bottom">
                    <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                      <div class="bet-inner yb-flex-center fit">
                        <div class="handicap-wrap">
                          <div class="bet-item">
                            <div class="item-label bet-ellipsis ellipsis">
                              <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}</span>
                              <span class="ellipsis-wrap"></span>
                            </div>
                          </div>
                        </div>
                        <odd1x2 :event="newAllBetEvent" :team="teamDraw" :plyType="plytyp" :betType="bettyp" ref="teamX" :mode="'ab'" />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </template>
        </template>
      </div>
    </template>
    <!-- HMG -->
    <template v-else>
      <div data-template="template0" class="wrap-template template0">
        <div class="main-handicap">
          <div class="vrow items-center template-title is_fold">
            <div class="play-name col" @click="showLeg()">
              <span class="ellipsis">{{ getTitleCaption(bettyp) }}</span>
            </div>
            <div style="width: 37px;" @click="setToTop($event)">
              <span class="set_top" style="display: none;">
                <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
              </span>
            </div>
          </div>
          <template v-if="show">
            <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][bettyp]).length)">
              <template
                v-if="newAllBetEvent.od[plytyp][bettyp][Object.keys(newAllBetEvent.od[plytyp][bettyp])[subMatchKey]]">
                <template v-if="subMatchKey == 0">
                  <div class="handicap">
                    <div class="handicap-item m-oe os-1 no_border_bottom">
                      <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                        <div class="bet-inner yb-flex-center fit">
                          <div class="handicap-wrap">
                            <div class="bet-item">
                              <div class="item-label bet-ellipsis ellipsis">
                                <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_1HT'] }}</span>
                                <span class="bet_handicap yb-family-odds"></span>
                              </div>
                            </div>
                          </div>
                          <odd1x2 :event="newAllBetEvent" :team="teamHome" :plyType="plytyp" :betType="bettyp" ref="team1" :mode="'ab'" />
                        </div>
                      </div>
                    </div>
                    <div class="handicap-item m-oe os-1 no_border_bottom">
                      <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                        <div class="bet-inner yb-flex-center fit">
                          <div class="handicap-wrap">
                            <div class="bet-item">
                              <div class="item-label bet-ellipsis ellipsis">
                                <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_2HT'] }}</span>
                                <span class="bet_handicap yb-family-odds"></span>
                              </div>
                            </div>
                          </div>
                          <odd1x2 :event="newAllBetEvent" :team="teamAway" :plyType="plytyp" :betType="bettyp" ref="team2" :mode="'ab'" />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </template>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd1x2'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    bettyp: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption(btype) {
      if (btype == this.hmgBetType || btype == this.rhmgBetType) {
        return this.sportAllBetLang['ALL_BET.SUBHEADER_HMG']
      } else if (btype == this.hmg1x2BetType || btype == this.rhmg1x2BetType) {
        return this.sportAllBetLang['ALL_BET.SUBHEADER_HMG1x2']
      }
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, bettyp) {
      if (this.selectMarket)
        this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
    },
    removeFromMyMarket(plytyp, bettyp) {
      if (this.removeMarket)
        this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
    },
    oddsHeader() {
      var retCapt = ''
      if (this.isSpecial) {
        retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.bettyp)
      }

      return retCapt
    },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-hmg.vue